/*
 * Copyright Camunda Services GmbH and/or licensed to Camunda Services GmbH under
 * one or more contributor license agreements. See the NOTICE file distributed
 * with this work for additional information regarding copyright ownership.
 * Licensed under the Camunda License 1.0. You may not use this file
 * except in compliance with the Camunda License 1.0.
 */

import { styles } from '@carbon/elements';
import styled from 'styled-components';

export const VersionDescription = styled.p`
  margin: 6px 0;
  word-break: break-word;
  ${styles.label01};
  color: var(--cds-text-secondary);

  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
`;
